import { useCallback, useMemo } from 'react';
import { PaginationState } from '@tanstack/react-table';

import { Pagination } from '../../../../types';
import {
  convertPaginationToReactTablePaginationState,
  convertReactTablePaginationStateToPagination,
} from '../../logic/paginationConversions';

export const useTablePagination = (
  pagination: Pagination,
  onPaginationChange: (pagination: Pagination) => void,
) => {
  const paginationState = useMemo(
    () => convertPaginationToReactTablePaginationState(pagination),
    [pagination],
  );

  const onPaginationStateChange = useCallback(
    (
      nextPaginationFn: (prevPagination: PaginationState) => PaginationState,
    ) => {
      const nextPaginationState = nextPaginationFn(paginationState);
      const nextPagination =
        convertReactTablePaginationStateToPagination(nextPaginationState);
      onPaginationChange(nextPagination);
    },
    [pagination, onPaginationChange, paginationState],
  );

  return {
    paginationState,
    onPaginationStateChange,
  };
};
